<template>
	<v-dialog v-model="loadingDialogOpen" :scrim="false" persistent width="300px">
		<v-card color="primary">
			<v-card-title>
				<span class="white--text text-subtitle-1">{{ $t('loading') }}</span>
				<v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
				<span class="white--text text-subtitle-1 mt-2">{{ $t('pleaseWait') }}</span>
			</v-card-title>
		</v-card>
	</v-dialog>
</template>

<script>
// locals
import i18n from './dictionary';
// components
import { mapStores } from 'pinia';
import { useGlobalOverlayLoaderStore } from '@/plugins/clientModels/store/globalOverlayLoaderStore';

export default {
	name: 'LoadingDialog',
	components: {},
	i18n,
	props: {},
	data() {
		return {};
	},
	computed: {
		...mapStores(useGlobalOverlayLoaderStore),
		loadingDialogOpen: {
			get() {
				return !this.globalOverlayLoaderStore.overlayLoaderUUIDArray.length == 0;
			},
		},
	},
	methods: {},
};
</script>
